import { render, staticRenderFns } from "./CharityEventDetail.vue?vue&type=template&id=6d5328cf&scoped=true"
import script from "./CharityEventDetail.vue?vue&type=script&lang=js"
export * from "./CharityEventDetail.vue?vue&type=script&lang=js"
import style0 from "./CharityEventDetail.vue?vue&type=style&index=0&id=6d5328cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5328cf",
  null
  
)

export default component.exports